<template>
    <div phone_edit :class="{dimOpen:isDim}" :style="`height:${this.winH}px`">
  
      <div class="dim"></div>
  
      <section class="phone-edit">
        <div class="top-btns type1">
          <a @click="back" class="back">뒤로가기 </a>
          <h2>전화번호 수정</h2>
        </div>
  
        <div class="wrap">
          <p class="tit">알림, 푸시, 로그인을 할 때<br> 전화번호가 큰 도움이 돼요</p>
  
          <span>전화번호</span>
          <div class="phone-wrap">
            <label>
              <input type="number" placeholder="+82" value="+82" readonly>
            </label>
            <label>
              <input type="tel" ref="new_phone_number_input" v-model="newPhoneNumber" placeholder="휴대폰 번호 입력" @click="select($event)">
            </label>
          </div>
  
          <div class="btn-wrap">
            <a class="btn save" @click="sendAuthNumber(true)">다음</a>
          </div>
        </div>
      </section>
  
      <CommonPopupFrame class="phone-cert" :closeCompleteAction="close" closeType="cert" :isOpen="isCert">
        <div class="inner">
          <div class="top-btns type2">
            <a class="back" @click="close('cert')">닫기</a>
            <h3>전화번호 인증하기</h3>
          </div>
  
          <div class="wrap">
            <div class="inp-wrap">
              <p class="tit">문자 메시지를 통해 <span>{{newPhoneNumber}}</span> 번호로<br> 보내드린 인증 코드를 입력해주세요</p>
  
              <div class="cert-wrap error" @click="checkFirstTouch">
                <label><input type="tel" v-model="auth_number1" placeholder="ㅡ" @keyup="goNext($event, 1)" ref="auth_number_input1" style="font-size:20px;"></label>
                <label><input type="tel" v-model="auth_number2" placeholder="ㅡ" @keyup="goNext($event, 2)" ref="auth_number_input2" style="font-size:20px;"></label>
                <label><input type="tel" v-model="auth_number3" placeholder="ㅡ" @keyup="goNext($event, 3)" ref="auth_number_input3" style="font-size:20px;"></label>
                <label><input type="tel" v-model="auth_number4" placeholder="ㅡ" @keyup="goNext($event, 4)" ref="auth_number_input4" style="font-size:20px;"></label>
                <label><input type="tel" v-model="auth_number5" placeholder="ㅡ" @keyup="goNext($event, 5)" ref="auth_number_input5" style="font-size:20px;"></label>
                <label><input type="tel" v-model="auth_number6" placeholder="ㅡ" @keyup="goNext($event, 6)" ref="auth_number_input6" style="font-size:20px;"></label>
              </div>
  
              <div class="msg">
                <p>문자 메시지가 오지 않았나요?</p>
                <a class="code-send" @click="sendAuthNumber(false)">다시 보내기</a>
              </div>
            </div>
  
            <div class="btn-wrap">
              <a class="btn save" @click="changePhone">완료</a>
            </div>
          </div>
        </div>
      </CommonPopupFrame>

    </div>
  </template>
  
  <script>
  import CommonPopupFrame from './CommonPopupFrame';
  import ResponseCode from "../../../ResponseCode";

  export default {
      name: "PhoneEdit",
      components : {CommonPopupFrame},
      props : {
          completeAction : {
              type : Function,
              default : () => {}
          }
      },
      data() {
          return {
              isDim: false,
              isCert: false,
              winH: 0,
              newPhoneNumber : '',
              authNumber : '',
              is_first_touch : true,
              auth_number1 : '',
              auth_number2 : '',
              auth_number3 : '',
              auth_number4 : '',
              auth_number5 : '',
              auth_number6 : '',
              intervalDetectChange : null,
          }
      },
      mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        this.$Util.setPhoneFormatter(this.$refs.new_phone_number_input);
      },
      methods: {
          select(e){
              setTimeout(() => {
                  e.target.select()
              }, 100)
          },
          checkFirstTouch(){
              if(this.is_first_touch){
                  this.$refs['auth_number_input1'].focus();
                  this.is_first_touch = false;
              }
          },
          goNext(e, i){
              const idx = parseInt(i);

              //지우기
              if(e.keyCode === 8){
                  if(i === 1) return;
                  const nextIdx = idx - 1;
                  this['auth_number' + nextIdx] = null;
                  this.$refs['auth_number_input' + nextIdx].focus();
                  return;
              }

              if(i === 6){
                  this.$refs['auth_number_input6'].blur();
              } else {
                  const nextIdx = idx + 1;
                  this.$refs['auth_number_input' + nextIdx].focus();
              }
          },
          handleResize() {
            this.winH = window.innerHeight;
          },
          editPageOpen() {
            this.is_first_touch = true;
            this.isCert = true;
            this.isDim = true;
          },
          close() {
            this.isCert = false;
            this.isDim = false;
          },
          back() {
            this.$GlobalStore.closeLastModal()
          },
          async sendAuthNumber(is_show_next){
              if(!this.newPhoneNumber){
                this.$GlobalStore.showAlert('휴대폰번호를 입력해주세요.');
                return;
              }

              const parameters = {};
              parameters.phone = this.newPhoneNumber;

              const res = await this.$Axios.post('/api/auth/number', parameters);
              if(res.data.code === ResponseCode.SUCCESS){
                if(is_show_next){
                  this.editPageOpen();
                } else {
                  this.$GlobalStore.showAlert('전송되었습니다.');
                }
              }else {
                this.$GlobalStore.showAlert(res.data.msg);
              }
          },
          async changePhone(){
              if(this.auth_number1 == null
                      || this.auth_number2 == null
                      || this.auth_number3 == null
                      || this.auth_number4 == null
                      || this.auth_number5 == null
                      || this.auth_number6 == null){
                  this.$GlobalStore.showAlert('인증번호를 정확히 입력해주세요');
                  return;
              }

              const parameters = {};
              parameters.authNumber = `${this.auth_number1}${this.auth_number2}${this.auth_number3}${this.auth_number4}${this.auth_number5}${this.auth_number6}`;
              parameters.phone = this.newPhoneNumber;
              const res = await this.$Axios.post('/api/my/phone/change', parameters);
              if(res.data.code === 0){
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                this.completeAction();
                this.$GlobalStore.closeLastModal();

              } else {
                this.$GlobalStore.showAlert(res.data.msg);
              }
          },
      },
      beforeDestroy(){
          clearInterval(this.intervalDetectChange);
      },
      created(){
          this.sendAuthNumber = this.$Once(this.sendAuthNumber);
          this.changePhone = this.$Once(this.changePhone);

          this.newPhoneNumber = this.$GlobalStore.loginInfo().phone;

          this.intervalDetectChange = setInterval(() => {
              let numbers = '';
              const cnt = 6;

              if(this.auth_number1.trim().length === cnt){
                  numbers = this.auth_number1;
              }else if(this.auth_number2.trim().length === cnt){
                  numbers = this.auth_number2;
              }else if(this.auth_number3.trim().length === cnt){
                  numbers = this.auth_number3;
              }else if(this.auth_number4.trim().length === cnt){
                  numbers = this.auth_number4;
              }else if(this.auth_number5.trim().length === cnt){
                  numbers = this.auth_number5;
              }else if(this.auth_number6.trim().length === cnt){
                  numbers = this.auth_number6;
              }

              if(numbers){
                  this.$nextTick(() => {
                      this.auth_number1 = numbers[0];
                      this.auth_number2 = numbers[1];
                      this.auth_number3 = numbers[2];
                      this.auth_number4 = numbers[3];
                      this.auth_number5 = numbers[4];
                      this.auth_number6 = numbers[5];
                      this.$refs.auth_number_input6.focus();
                  })
              }
          }, 100);
      }
  }
  </script>
  
  <style scoped>
    *{font-family:var(--global-font-family); color: #101014;}
    h2, h3, h4, p, ul { margin: 0; padding: 0; list-style: none; margin-block: 0; margin-inline: 0; }
    a { display: inline-block; text-decoration: none; color: #101014; }
    h2 { font-size: 24px; font-weight: 500; line-height: 35px; padding: 18px 20px 10px 20px; box-sizing: border-box; border-bottom:1px solid; border-color: #F5F5F5; }
    h3 { font-size: 20px; line-height: 29px; font-weight: 500; display: inline-block; }
    section .wrap { padding: 30px 20px; box-sizing: border-box; }
    input { outline: none; }
    input[type=number]::-webkit-outer-spin-button,input[type="number"]::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0;}
  
    [privacy] { overflow: hidden; }
    .dim { background: rgba(0,0,0,0.3); position: fixed; left:0; top:0; width:100%; height:100%; opacity: 0; transition: opacity 0.3s; animation-timing-function: ease-out; }
  
    section { background: #fff; position: relative; }
    .top-btns { height: 100px; border-bottom: 1px solid; border-color: #F5F5F5; position: relative; }
    .top-btns .back { font-size: 0; width:65px; height:53px; display: block; }
    .top-btns.type1 .back:after { content: ''; width:25px; height:29px; background: url("~@/assets/images/mypage/ico-back.png")0 0 no-repeat; background-size: contain; position: absolute; left:20px; top:12px; }
    .top-btns.type1 h2 { padding-top: 0; }
    .top-btns.type1 .status-txt { font-size: 16px; font-weight: 500; color:#bbb; position: absolute; right:20px; bottom: 15px; }
  
    .top-btns.type2 { height:70px; }
    .top-btns.type2 .back { position: absolute; left: 0; top: 17px; }
    .top-btns.type2 .back:after { content: ''; width:22px; height:22px; background: url("~@/assets/images/mypage/ico-close.png")0 0 no-repeat; background-size: contain; position: absolute; left:20px; top:16px; }
    .top-btns.type2 h3 { text-align: center; display: block; padding-top: 30px; }
  
    .wrap .inp-wrap { padding-bottom: 30px; border-bottom: 1px solid rgb(245,245,245); }
    .wrap .inp-wrap .tit { font-size: 16px; line-height: 23px; font-weight: 500; margin-bottom: 40px; }
    .wrap .inp-wrap label { border: 1px solid rgb(229,229,229); border-radius: 5px; padding:10px 12px; box-sizing: border-box; display: block; }
    .wrap .inp-wrap label span { font-size: 12px; color:#808080; display: block; }
    .wrap .inp-wrap label input { font-size: 16px; color:#606060; font-weight: 500; display: block; border: none; }
  
    .phone-edit { height: 100%; }
    .phone-edit .wrap .tit { font-size: 20px; line-height: 29px; color:#606060; font-weight: 500; margin-bottom: 30px; }
    .phone-edit .wrap span { font-size: 14px; color:#808080; font-weight: 500; display: block; }
    .phone-edit .wrap .phone-wrap { margin-top: 10px; padding: 6px 0; border-bottom: 1px solid rgb(245,245,245); box-sizing: border-box; }
    .phone-edit .wrap .phone-wrap label { display: inline-block; box-sizing: border-box; position: relative; }
    .phone-edit .wrap .phone-wrap label input { padding: 0 26px 0 12px; box-sizing: border-box; border: none; }
    .phone-edit .wrap .phone-wrap label:nth-child(1) { width: 70px; }
    .phone-edit .wrap .phone-wrap label:nth-child(1):after { content:''; width:1px; height:25px; background: #F5F5F5; position: absolute; right: 0; top: 0; }
    .phone-edit .wrap .phone-wrap label:nth-child(1) input { font-size: 16px; color:#606060; }
    .phone-edit .wrap .phone-wrap label:nth-child(2) input { font-size: 20px; color:var(--color-main); }
    .phone-edit .wrap .phone-wrap label:nth-child(2) input::placeholder { font-size: 20px; color:#BBBBBB; }
  
    .phone-cert .wrap .tit span { color:var(--color-main); }
    .phone-cert .wrap .cert-wrap { width: 232px; height: 54px; border: 1px solid rgb(245,245,245); border-radius: 5px; display: block; padding: 0; text-align: center; overflow: hidden; }
    .phone-cert .wrap .cert-wrap label { display: inline-block; vertical-align: middle; border: none; padding: 0; }
    .phone-cert .wrap .cert-wrap input { width: 30px; height: 52px; line-height: 52px; text-align: center; border: none; }
    .phone-cert .wrap .cert-wrap.error input::placeholder { color:var(--color-main); }
    .phone-cert .wrap .inp-wrap .msg { margin-top: 30px; }
    .phone-cert .wrap .inp-wrap .msg p, .phone-cert .wrap .inp-wrap .code-send { font-size:16px; color:#ADADAD; display: inline-block; }
    .phone-cert .wrap .inp-wrap .code-send { color:#101014; border-bottom: 1px solid; border-color: #101014; margin-left: 8px; }
  
    .edit-page { position: fixed; left:0; bottom:0; width:100%; height:100%; z-index: 10; background: #fff; transform: translateY(100%); transition: transform 0.5s; animation-timing-function: ease-out;  border-top-left-radius: 25px; border-top-right-radius: 25px; }
    .btn-wrap { width: 100%; position: absolute; left:0; bottom: 30px; text-align: center; }
    .btn { font-size: 20px; font-weight: 500; text-align: center; border: 1px solid; border-color: var(--color-main); line-height: 44px; padding: 0 100px; box-sizing: border-box; border-radius: 23px; cursor:pointer; }
    .edit-page.open { transform: translateY(0); }
    .dimOpen .dim { opacity:0.5; z-index: 5; }
    .error { border-color: var(--color-main) !important; }
  </style>